<template>
  <div style="margin-bottom: 10px;" id="divMenu">
    <div style="    position: absolute; background: #545c64;
    width: 100%;
    min-width: 1100px;
    left: 0px;
    top: 0px;">
      <div style="float: left;
    width: 400px;
    text-align: center;
    line-height: 60px;
    font-size: 28px;
    font-weight: 700;
    background: #545C64;
    cursor: pointer;
    color: #FF9900;" @click="MenuJump('../#/Home')">
        云贸通在线报关服务平台
      </div>
      <div style="float: left; width: calc(100% - 400px); ">
        <el-menu :default-active="activeIndex.toString()" class="el-menu-demo" mode="horizontal" @select="handleSelect"
          background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
          <el-submenu :index="ip + 1 + ''" v-for="(item, ip) in PermissiosData">
            <template slot="title">{{ item.Name }}</template>
            <el-menu-item v-for="(i, ic) in item.ChildMenus" :index="ip + 1 + '-' + (ic + 1)" @click="MenuJump(i.Link)">
              {{ i.Name }}
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div style="position: absolute;
    top: 10px;
    right: 10px;
    color: #fff; cursor: pointer;" @click="NowUser()" id="txtUser"></div>

      <!--      <template>-->
      <!--        <el-button-->
      <!--          plain-->
      <!--          @click="SlidingWindow('CustomsDeclaration')">-->
      <!--          报关服务消息-->
      <!--        </el-button>-->
      <!--        <el-button-->
      <!--          plain-->
      <!--          @click="SlidingWindow('system')">-->
      <!--          系统消息-->
      <!--        </el-button>-->
      <!--      </template>-->

      <div style="position: absolute;
    top: 35px;
    right: 15px;
    cursor: pointer;" title="首页" @click="MenuJump('../#/Home')">
        <svg id="homesvg" class="icon"
          style="width: 2em;height: 1.8em;vertical-align: middle;fill: currentColor;overflow: hidden;"
          viewBox="0 0 1251 1024" version="1.1">
          <path
            d="M1223.812765 472.990476l-168.671861-141.852814V82.008658a77.575758 77.575758 0 0 0-155.151515 0v119.245022L681.447397 17.953247a76.910823 76.910823 0 0 0-54.967965-17.731602h-1.77316a76.245887 76.245887 0 0 0-54.74632 17.731602L27.594584 472.990476a77.797403 77.797403 0 0 0-9.530736 109.270996 77.797403 77.797403 0 0 0 109.270995 9.530736L625.592852 173.769697 1124.072506 591.792208a77.797403 77.797403 0 0 0 108.384415-9.530736 78.019048 78.019048 0 0 0-8.644156-109.270996z"
            fill="#FF9900"></path>
          <path
            d="M168.560817 623.709091V935.341991a88.658009 88.658009 0 0 0 88.658009 88.658009h243.809524v-310.30303h243.809524v310.30303h243.809523a88.658009 88.658009 0 0 0 88.658009-88.658009V615.28658L622.933112 248.242424z"
            fill="#FF9900"></path>
        </svg>
      </div>

      <!--      <div v-show="isOrderChatBoard" style="position: absolute;-->
      <!--    top: 35px;-->
      <!--    right: 15px;-->
      <!--    cursor: pointer;" title="沟通面板"-->
      <!--           @click="MenuJump('../#/Home')">-->
      <!--        <el-badge :value="3" :max="99" class="item">-->
      <!--          <svg class="icon" style="width: 2em;height: 1.8em;vertical-align: middle;fill: currentColor;overflow: hidden;"-->
      <!--               viewBox="0 0 1024 1024" version="1.1">-->
      <!--            <path-->
      <!--              d="M512.824785 2.489704c-283.043425 0-512.477884 203.929576-512.477884 455.538057 0 147.789974 72.163553 279.138488 194.830337 362.373191 0.726547 0.485047-12.627598 201.108321-12.627598 201.108321l206.019167-120.274294c37.784558 7.897877 80.438007 12.332886 120.917954 12.332886 283.043425 0 514.166339-203.929576 514.166339-455.540104C1023.653099 206.420303 795.868209 2.489704 512.824785 2.489704zM263.463484 523.996219c-35.317367 0-63.956637-28.636201-63.956637-63.956637 0-35.322483 28.639271-63.956637 63.956637-63.956637 35.32453 0 63.956637 28.634154 63.956637 63.956637C327.420121 495.361041 298.788014 523.996219 263.463484 523.996219zM512 523.996219c-35.32453 0-63.956637-28.636201-63.956637-63.956637 0-35.322483 28.632107-63.956637 63.956637-63.956637 35.317367 0 63.956637 28.634154 63.956637 63.956637C575.956637 495.361041 547.316344 523.996219 512 523.996219zM760.52833 523.996219c-35.32453 0-63.956637-28.636201-63.956637-63.956637 0-35.322483 28.632107-63.956637 63.956637-63.956637s63.956637 28.634154 63.956637 63.956637C824.484967 495.361041 795.85286 523.996219 760.52833 523.996219z"-->
      <!--              p-id="6821" fill="#f90"></path>-->
      <!--          </svg>-->
      <!--        </el-badge>-->
      <!--      </div>-->

      <!--      <div style="position: absolute;-->
      <!--    top: 35px;-->
      <!--    right: 10px;-->
      <!--    cursor: pointer;" title="在线客服沟通" v-if="false"-->
      <!--           @click="MenuJump('../#/Home')">-->
      <!--        <svg class="icon" style="width: 2em;height: 1.8em;vertical-align: middle;fill: currentColor;overflow: hidden;"-->
      <!--             viewBox="0 0 1024 1024" version="1.1">-->
      <!--          <path-->
      <!--            d="M516.667511 807.863307c5.004179 0 10.095748-0.308016 15.221701-0.916884 49.157857-5.899573 90.900417-40.259787 106.306927-87.609664 1.163296-3.541463-0.515747-7.336502-3.906784-8.892339-3.352356-1.561567-7.409566-0.212029-9.306369 2.965546-0.179079 0.302285-19.710133 31.848813-95.745574 42.117909-11.382251 1.527184-22.457919 2.328025-32.956236 2.328025-53.270939-0.034383-77.00963-20.112702-77.22739-20.297512-2.680452-2.383897-6.772045-2.445501-9.519831-0.123206-2.775006 2.322294-3.413959 6.358015-1.521454 9.446767C431.202495 784.477044 472.816118 807.863307 516.667511 807.863307L516.667511 807.863307zM516.667511 807.863307M925.504492 336.633827c-0.670471 0-1.280772 0.123206-1.918292 0.123206C879.03425 143.879099 708.803342 0 504.703612 0c-209.712777 0-383.850469 151.824469-422.446972 352.685021C44.728879 359.438442 16.165088 392.423331 16.165088 432.3135l0 159.653796c0 44.746787 35.883101 81.032457 80.188637 81.032457 24.992242 0 47.051889-11.802012 61.726326-29.927655 35.457609 93.781437 107.642139 169.397117 198.995267 209.293016 0.21776-0.475633 1.946945-3.83945 4.028557-6.519902 1.438361-1.858122 3.050071-3.379576 4.432559-3.379576 1.432631 0 2.747786 0.520045 3.872401 1.313722-21.142764-15.741746-97.51344-96.656727-114.056026-209.572379-7.257707-49.699391 29.967769-98.487629 73.322038-106.557638 69.600064-12.959577 138.836239-27.722836 208.436303-40.437434 44.243933-8.070009 74.479604-32.340205 92.969135-72.750419 4.332275-9.446767 10.588573-28.546599 13.459565-56.091789 0.760727-4.095891 4.118813-7.240515 8.422436-7.240515 2.870992 0 5.310762 1.465581 6.928202 3.575846l1.919725-1.191949c27.432012 39.827133 81.833297 128.012715 89.645432 220.999042 8.971133 106.311225 3.966954 179.124679-77.406468 253.615744-0.095986 0.094554-0.219192 0.212029-0.336668 0.308016-1.130346 1.219169-1.802249 2.807956-1.802249 4.554333 0 2.289344 1.220601 4.24775 2.988468 5.439699 0.671904 0.275065 1.343808 0.643251 2.015711 0.918316 0.547265 0.123206 1.068742 0.302285 1.61744 0.302285 0.552995 0 1.04009-0.179079 1.527184-0.302285 1.158998-0.610301 2.254961-1.315155 3.385306-1.925456 82.293172-45.335598 145.423475-121.045832 174.596134-212.108136 11.809175 17.543995 30.298706 30.16977 51.776705 34.573676C874.366739 816.570836 734.623645 914.634406 561.493092 929.519439c-10.375111-25.73721-35.916051-44.014712-65.91104-44.014712-39.173853 0-70.938141 31.026483-70.938141 69.264828 0 38.239778 31.758557 69.230445 70.938141 69.230445 31.585209 0 58.037302-20.291781 67.220464-48.172207 200.406408-16.290443 361.057315-135.410819 394.595199-320.495243 29.626803-12.38366 50.432898-41.450304 50.432898-75.380729L1007.830614 418.406954C1007.830614 373.256165 970.969026 336.633827 925.504492 336.633827L925.504492 336.633827zM851.573585 383.038168C799.305488 241.448412 663.860285 140.301821 504.524533 140.301821c-158.669579 0-293.627687 100.289878-346.382879 240.96275-2.624579-3.211958-5.703303-5.959744-8.724721-8.741912C179.282985 201.099801 326.816725 70.76336 504.703612 70.76336c177.035904 0 324.10977 129.054237 354.955741 299.286578C856.610715 374.145829 853.801326 378.420799 851.573585 383.038168L851.573585 383.038168zM851.573585 383.038168M357.086779 852.365114c-0.005731 0-0.005731 0-0.011461 0C357.042368 852.436745 357.042368 852.448206 357.086779 852.365114L357.086779 852.365114zM357.086779 852.365114"-->
      <!--            p-id="33112" fill="#f90"></path>-->
      <!--        </svg>-->
      <!--      </div>-->

      <div style="clear: both;"></div>
    </div>
    <div style="width: 100%; height: 52px;"></div>
  </div>
</template>

<script>
const axios = require("axios");
const token = localStorage.getItem("Token");
import common from '@/utils/common.js'
import { getSingleLogin } from '@/utils/commonApi.js'
import request from '@/utils/request.js'
export default {
  name: "NavMenu",
  data() {
    return {
      PermissiosData: [],
      // 菜单默认项
      activeIndex: "",
      isOrderChatBoard: false //沟通面板
    };
  },
  created: function () {
    this.getHousePermission();
    console.log(this.$route, '路由')
    if (this.$route.path != '/SsoLogin') {
      // this.singleLogin()
    }

  },
  methods: {
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
      this.activeIndex = keyPath[1]; //菜单第二层索引
    },
    NowUser() {
      this.activeIndex = "/";
      const url = "#/PersonalCenter/EssentialInformation";
      window.location.href = url;
    },
    //电委角色没有右上角首页图标权限
    getHousePermission() {
      let role = localStorage.getItem("UserRole");
      if (role == "electricEntrustPerson") {
        this.$nextTick(() => {
          document.getElementById("homesvg").style.display = "none";
        });
      }
    },
    //加载权限
    onloadPermissions(act) {
      var url = window.location.hash;
      var UrlName = url.substr(url.length - 5, 5);
      // console.log(UrlName);
      if (UrlName == "Login") {
        return;
      }
      let $this = this;
      axios({
        url: "User/Permissions", //1、请求地址
        method: "get", // 2、请求方法
        responseType: "application/json; charset=utf-8",
        headers: {
          Accept: "application/json; charset=utf-8",
          Token: localStorage.getItem("Token") //token
        }
      })
        // 2、回调函数
        .then(resp => {
          // console.log('权限')
          // console.log(resp.data)
          if (resp.data.ResponseCode == 200) {
            var MenusList = resp.data["DomainObj"]["Menus"];
            $this.PermissiosData = MenusList;
            var bts = resp.data["DomainObj"]["Buttons"];
            if (bts.length > 0) {
              for (let item of bts) {
                if (item.Id == "Order_Chat_Board") {
                  $this.isOrderChatBoard = true; //沟通面板
                }
              }
            }
          } else {
            $this.$message.error(resp.data.Message);
          }
          if (act == "") {
            $this.activeIndex = "/";
          } else if (act != null && act != undefined) {
            $this.activeIndex = act;
          }
        })
        // 3、捕获异常
        .catch(err => {
          // console.log('请求失败：'+err);
          $this.RequestFailed(err);
        });
    },
    // 菜单跳转
    MenuJump(url) {
      let role = localStorage.getItem("UserRole");
      if (role == "electricEntrustPerson" && url == "../#/Home") {
        return "";
      }
      window.location.href = url;
    },
    RequestFailed(err) {
      //console.log(err.response)
      let $this = this;
      if (err.response.data["ResponseCode"] == 401) {
        // common.clearCache();
        getSingleLogin()
        // SsoLoginApi({ urlType: 'ssoLoginRead', token: '' });
        return false;
      } else if (err.response.data["ResponseCode"] == 403) {
        $this.$message.error("您登陆的账号没有相关的操作权限");
        return false;
      } else {
        // console.log(err);
        $this.$message.error(
          "操作异常：" + err.status + "," + err.statusText + ",请联系管理员！"
        );
        return false;
      }
    },

    fatherMethod() {
      console.log("测试111");
    },
    //
    // singleLogin() {
    //   const token = localStorage.getItem('Token');
    //   if (!token) {
    //     const url = window.location.origin + '/#/Home'
    //     getSsoUrl({ ssoUrlType: 'NetflowUserLoginCallbackUrl', callbackUrl: url });
    //   }
    // else {
    //   getUserLoginByTokenApi(token)
    // }
  },
  // getSsoUrl(e) {
  //   request.get('Sso/GetSsoUrl', {
  //     params: {
  //       SsoUrlType: 'NetflowUserLoginCallbackUrl',
  //       CallbackUrl: window.location.origin + '/#/Home'
  //     }
  //   }).then(res => {
  //     if (res.data.ResponseCode == 200 && res.data.DomainObj) {
  //       window.location.href = res.data.DomainObj;
  //       console.log(res, '地址')
  //     }
  //     else {
  //       this.$alert(res.data.Message, '异常', {
  //         confirmButtonText: '确定',
  //         callback: action => {
  //           console.log('回调')
  //         }
  //       });
  //     }
  //     console.log('res', res)
  //   })
  // }
}

</script>

<style scoped>
a {
  text-decoration: none;
}

li a {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/NavMenu.vue